module.exports = __webpack_public_path__ + "img/defaultCarousel.65b56051.jpg";